export default __webpack_public_path__ + "static/media/logo-link4pay.ba4d4842.png";